import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BasicCard from '../common/BasicCard.tsx';
import { useEffect, useState } from 'react';
import axios from 'axios';
import IResponse from '../../interfaces/response.ts';

const CreateCampaign = () => {
	const { t } = useTranslation();
	const [data, setData] = useState<any>('');
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();

	const handleClick = (title: string) => () => {
		const media = searchParams.get('media');
		navigate(`${title}${media ? `?media=${media}` : ''}`);
	};

	useEffect(() => {
		const fetchData = async () => {
			try {
				const res = await axios<IResponse<any>>({
					url: '/settings',
				});

				if (res.data.success) {
					setData(res.data.data);
				}
			} catch (error) {
				console.error('Error fetching data:', error);
			}
		};

		fetchData();
	}, []);
	return (
		<div className="flex h-full w-full flex-col gap-y-8 pt-6">
			<div className="flex w-full flex-col gap-x-4 gap-y-6 md:flex-row">
				<BasicCard paperClasses="w-1/2 h-[521px] basis-1/2" buttonClasses="self-end" contentWrapperClasses="pt-0" color="primary" title={data?.campaign_reportage_title} image="/images/campaigns/reportage.svg" subject={t('what_is_reportage_ad')} description={data?.campaign_reportage_description} onClick={handleClick('reportage')} />
				<BasicCard paperClasses="w-1/2 h-[521px] basis-1/2" buttonClasses="self-end" contentWrapperClasses="pt-0" color="secondary" title={data?.campaign_advertising_title} image="/images/campaigns/advertisement.svg" subject={t('What_is_advertisement')} description={data?.campaign_advertising_description} onClick={handleClick('advertising')} />
			</div>

			{/* {data && data.campaign_create_video && (
				<Card>
					<video controls className="h-[392px] w-full rounded-lg">
						<source src={data?.campaign_create_video} type="video/mp4" />
					</video>
				</Card>
			)} */}
		</div>
	);
};

export default CreateCampaign;
